import React, { useState, useEffect } from "react";
import styles from "./TabGroup.module.css";

interface TabOption {
    value: string | number;
    label: string;
    disabled?: boolean;
}

interface TabGroupProps {
    options: TabOption[];
    value?: string | number;
    onChange?: (value: string | number) => void;
    disabled?: boolean;
}

const TabGroup: React.FC<TabGroupProps> = ({
    options,
    value,
    onChange,
    disabled = false,
}) => {

    const [selected, setSelected] = useState<string | number>(
        value ?? options[0]?.value
    );

    useEffect(() => {
        if (value !== undefined) {
            setSelected(value);
        }
    }, [value]);

    const handleClick = (optionValue: string | number) => {

        if (disabled) return;

        setSelected(optionValue);

        if (onChange) {
            onChange(optionValue);
        }
    };

    return (
        <div className={styles.tabGroup}>

            {options.map((option) => {

                const isActive = selected === option.value;

                return (
                    <button
                        key={option.value}
                        className={`${styles.tabButton} ${isActive ? styles.active : ""}`}
                        onClick={() => handleClick(option.value)}
                        disabled={disabled || option.disabled}
                    >
                        {option.label}
                    </button>
                );

            })}

        </div>
    );
};

export default TabGroup;